import { Alert, Button, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { jcTypeArray } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import ImageUploader from "../FileManager/upload";

const AddBanner = ({ visibleData, onCloseMethod }: any) => {
  const [generatedImgUrl, setGeneratedImgUrl] = useState<string>();
  const [startUpload, setStartUpload] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >(undefined);
  const [bannerUrl, setBannerUrl] = useState(undefined);
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [bannerData, setBannerData] = useState(undefined);

  useEffect(() => {
    if (startUpload === "Uploaded") {
      form.submit();
    }
  }, [form, startUpload]);

  const onSubmit = async (data: any) => {
    if (generatedImgUrl) {
      setLoading(true);

      const readyData = data && {
        bannerName: data.bannerName,
        bannerImage: generatedImgUrl ? generatedImgUrl : data?.bannerImage,
        bannerPosition: data.bannerPosition,
        type: data.type,
      };

      if (bannerData) {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/banner`, {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...readyData,
            id: bannerData?.id,
            deleted: false,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Banner Updated Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      } else {
        await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/banner`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        })
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification("Banner Create Successfully", "success");
              form.resetFields();
              if (onCloseMethod) {
                onCloseMethod();
              }
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    } else {
      responseNotification(`Image required`, "error");
    }
  };

  useEffect(() => {
    if (visibleData) {
      setBannerData(visibleData);
      setGeneratedImgUrl(visibleData?.bannerImage);
    }
  }, [visibleData]);

  useEffect(() => {
    if (bannerData) {
      form.resetFields(Object.keys(visibleData));
      setBannerUrl(visibleData?.bannerImage);
    }
  }, [bannerData, form, visibleData]);

  // **********************************

  // **********************************
  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        {/* {bannerUrl && (
          <div className="mt-2" style={{ minWidth: "100%" }}>
            <Image
              src={bannerUrl}
              height={150}
              className="img img-thumbnail"
              onLoad={(e) => {
                const width = (e.target as any).naturalWidth;
                const height = (e.target as any).naturalHeight;
                const ratio = width / height;

                if (ratio.toFixed(1) === "2.5" && height > 400) {
                  setError("");
                } else {
                  setError(
                    "Image Ratio must be around 2.3 & minimum Height is 400"
                  );
                }
              }}
            />
            <p className="red-txt mt-1">{error}</p>
          </div>
        )} */}
        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          initialValues={{
            ...bannerData,
          }}
        >
          <Form.Item
            hasFeedback
            label="Type"
            rules={[
              {
                required: true,
                message: "Type is required!",
              },
            ]}
            name="type"
          >
            <Select placeholder="Shop Type" style={{ minWidth: 300 }}>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Banner Title"
            rules={[
              {
                required: true,
                message: "Banner Title is Required!",
              },
            ]}
            name="bannerName"
          >
            <Input
              id="bannerName"
              type="text"
              placeholder="Enter Banner Title"
            />
          </Form.Item>

          <Form.Item
            hasFeedback
            label="Banner Position"
            rules={[
              {
                required: true,
                message: "Banner Position is Required!",
              },
            ]}
            name="bannerPosition"
          >
            <Input
              id="bannerPosition"
              type="number"
              placeholder="Enter Banner Position"
            />
          </Form.Item>

          <h4 className="title" style={{ maxWidth: "99%" }}>
            Image:
          </h4>

          <div className="">
            <ImageUploader
              // crop={2.5}
              imgUrl={generatedImgUrl || ""}
              startUpload={startUpload}
              setStartUpload={(val: any) => setStartUpload(val)}
              setGeneratedImgUrl={(url: any) => setGeneratedImgUrl(url)}
            />
            {/* <Alert
              message="Image Ratio must be around 2.5 & minimum Height is 400"
              type="warning"
              className="mt-2"
            /> */}
          </div>

          <div className="buttons-container">
            <Button
              disabled={loading || !!error}
              loading={loading}
              type="primary"
              htmlType="submit"
              className="add-submit-btn text-center mr-2"
              onClick={(e) => {
                e.preventDefault();
                setStartUpload("Uploading");
              }}
            >
              Submit
            </Button>
            <Button
              type="ghost"
              htmlType="button"
              onClick={() => {
                form?.resetFields();
                setBannerUrl(undefined);
                setGeneratedImgUrl(undefined);
                setStartUpload(undefined);
              }}
              className="reset-submit-btn text-center mr-2"
            >
              Reset
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AddBanner;
